'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

var scrollAnimations = void 0,
    scrollAnimationKeys = void 0,
    activeClass = void 0,
    onloadAnimations = void 0,
    baseOffset = void 0;

function init() {
    activeClass = 'scroll-active';
    baseOffset = 0.1;

    setupScrollAnimation();

    _Observable.Observable.fromEvent(window, 'scroll').map(function () {
        return getCurrentTop() + window.innerHeight;
    }).subscribe(handleScroll);

    handleScroll(getCurrentTop() + window.innerHeight);
}

function setupScrollAnimation() {
    var scrollAnimationElements = document.querySelectorAll('.js-scroll-anim');
    scrollAnimationElements = Array.from(scrollAnimationElements);

    var blockquoteAnimationElements = document.querySelectorAll('.typography blockquote');
    blockquoteAnimationElements = Array.from(blockquoteAnimationElements);

    onloadAnimations = [];

    scrollAnimations = scrollAnimationElements.concat(blockquoteAnimationElements).reduce(function (acc, el) {
        if (el.classList.contains('onload')) {
            onloadAnimations.push(el);
            return acc;
        }

        var _el$getBoundingClient = el.getBoundingClientRect(),
            top = _el$getBoundingClient.top;

        var offset = el.dataset.scrollOffset || baseOffset;
        top = Math.round(top) + getCurrentTop() + offset * window.innerHeight;
        top = Math.max(top, 0);
        if (typeof acc[top] == 'undefined') {
            acc[top] = [];
        }
        acc[top].push(el);
        return acc;
    }, {});

    scrollAnimationKeys = Object.keys(scrollAnimations);
    scrollAnimationKeys.sort();

    if (onloadAnimations.length) {
        onloadAnimations.map(function (els) {
            els.map(function (el) {
                el.classList.add(activeClass);
            });
        });
    }
}

function handleScroll(scroll) {
    for (var i = 0; i < scrollAnimationKeys.length; i++) {
        var animScroll = scrollAnimationKeys[i];
        if (scroll >= animScroll) {
            scrollAnimations[scrollAnimationKeys[i]].map(function (el) {
                el.classList.add(activeClass);
            });
        }
    }
}

function getCurrentTop() {
    return window.scrollY || window.pageYOffset;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/scroll-anim.js
// module id = ./resources/assets/js/src/ui/scroll-anim.js
// module chunks = 0